import { render, staticRenderFns } from "./recommended-listing.vue?vue&type=template&id=19a89fd1"
import script from "./recommended-listing.vue?vue&type=script&lang=js"
export * from "./recommended-listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports